import block from './block.json';

export const pageHeaderSimpleThemeAttributes = {
	backgroundColor: '@tokens.variants.default.backgroundColor',
	padding: {
		top: [100, 160],
		bottom: [100, 160],
	},
	title: {
		color: '@tokens.variants.default.titleColor',
		typography: '@tokens.typographies.heading-1',
		textAlignment: 'left',
	},
};

export const PageHeaderSimpleThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: pageHeaderSimpleThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
